import { SocialAuthProviders } from '@config';

export interface AccountLinkingResult {
  provider: SocialAuthProviders;
  socialAccountId: string;
  linked: boolean;
}
